export default __webpack_public_path__ + "static/media/doctor4.3b6da610.jpg";